/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.booking', {
            parent: 'board',
            url: '/board/{select}/booking?page&sort&search',
            data: {
                authorities: ['ROLE_BOARD'],
                pageTitle: 'askApp.booking.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/board/booking/bookings.html',
                    controller: 'BoardBookingController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        select: $stateParams.select
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('booking');
                    $translatePartialLoader.addPart('enumBookingStatusType');
                    $translatePartialLoader.addPart('enumDeptStatus');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('dept');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'MemberManagement', function($stateParams, MemberManagement) {
                    if($stateParams.select) {
                        return MemberManagement.get({id : $stateParams.select}).$promise;
                    }
                    return null;
                }]
            }
        })
        .state('board.booking.edit', {
            parent: 'board.booking',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_BOARD']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/booking/booking-dialog.html',
                    controller: 'BoardBookingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['Booking', function(Booking) {
                            return Booking.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.booking', null, { reload: 'board.booking' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.booking.delete', {
            parent: 'board.booking',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_BOARD']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/booking/booking-delete-dialog.html',
                    controller: 'BoardBookingDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Booking', function(Booking) {
                            return Booking.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.booking', null, { reload: 'board.booking' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.booking.edit-dept', {
            parent: 'board.booking',
            url: '/dept/{deptId}/edit',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/dept/dept-dialog.html',
                    controller: 'BoardDeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('payment');
                            $translatePartialLoader.addPart('enumPaymentCategory');
                            return $translate.refresh();
                        }],
                        entity: ['Dept', function(Dept) {
                            return Dept.get({id : $stateParams.deptId}).$promise;
                        }],
                        entityProfile: null,
                        entityProject: null,
                        entityDinghyEvent: null
                    }
                }).result.then(function() {
                    $state.go('board.booking', null, { reload: 'board.booking' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.booking.new-dept', {
            parent: 'board.booking',
            url: '/dept/new/{projectId}/{userId}',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/dept/dept-dialog.html',
                    controller: 'BoardDeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('payment');
                            $translatePartialLoader.addPart('enumPaymentCategory');
                            return $translate.refresh();
                        }],
                        entity: function () {
                            return {
                                date: new Date(),
                                reference: null,
                                pointValue: 0,
                                amount: null,
                                comment: null,
                                category: "",
                                sepa: null,
                                paymentStatus: null,
                                id: null
                            };
                        },
                        entityProfile: ['MemberManagement', function(MemberManagement) {
                            return MemberManagement.get({id: $stateParams.userId}).$promise;
                        }],
                        entityProject:  ['Project', function(Project) {
                            return Project.get({id: $stateParams.projectId}).$promise;
                        }],
                        entityDinghyEvent: null
                    }
                }).result.then(function() {
                    $state.go('board.booking', null, { reload: 'board.booking' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
